import React from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { formatNumber } from '@/utils/format.number';

type Props = {
    id: string;
    label: React.ReactNode;
    count: number;
    collapsed: boolean;
    collapsible: boolean;
    sticky: boolean;
    onToggle: () => void;
    measure?: (node: HTMLElement | null) => void;
};

const ListGroup: React.FC<Props> = ({ id, label, count, collapsed, collapsible, sticky, onToggle, measure }) => {
    const body = (
        <>
            {collapsible ? <IconChevronDown size={14} className="bd-list-chevron" aria-hidden /> : null}
            <span className="bd-list-group-label" id={id}>{label}</span>
            <span className="bd-list-group-count">{formatNumber(count)}</span>
        </>
    );

    if (!collapsible) {
        return <div ref={measure} className="bd-list-group" data-sticky={sticky || undefined}>{body}</div>;
    }

    return (
        <button
            ref={measure}
            type="button"
            className="bd-list-group"
            data-sticky={sticky || undefined}
            aria-expanded={!collapsed}
            onClick={onToggle}
        >
            {body}
        </button>
    );
};

export default ListGroup;
